export default __webpack_public_path__ + "static/logoGrayscaleVector-81556ecb5da8932bd76e24652c96dfe4.svg";